import { ConnectedUser } from "@/dto";
import authenticationServices from "@/services/authenticationServices";
import userServices from "@/services/userServices";

// initial state
const state = () => ({
  connectedUser: null,
});
// getters
const getters = {
  currentConnectedUser: (state) => {
    return state.connectedUser;
  },
  storedCurrentId: () => {
    return +localStorage.getItem("current_user_id");
  },
};

// actions
const actions = {
  async login({ commit }, params) {
    let userDto = {};
    userDto = await authenticationServices.login(params.identifier, params.password, params.captcha);
    commit("storeConnectedUser", new ConnectedUser(userDto));
  },
  async logout({ commit }) {
    await authenticationServices.logout();
    commit("storeConnectedUser", null);
  },
  async getConnectedUser(state) {
    let connectedUser;
    //si l'utilisateur connecté est déjà enregistré dans le store, on le renvoie.
    if (state.getters.currentConnectedUser) {
      connectedUser = state.getters.currentConnectedUser;
    } else {
      //sinon on le récupère sur le serveur l'utilisateur connecté
      let userDto = await userServices.getConnectedUser();
      if (userDto) {
        connectedUser = new ConnectedUser(userDto);
        state.commit("storeConnectedUser", connectedUser);
      } else {
        connectedUser = null;
      }
    }

    return connectedUser;
  },
};

// mutations
const mutations = {
  /**
   * Sauvegarde l'utilisateur connecté dans l'état
   * @param {*} state état du store
   * @param {ConnectedUser} user utilisateur connecté
   */
  storeConnectedUser(state, user) {
    if (!user) {
      localStorage.clear();
    } else {
      localStorage.setItem("current_user_id", user.id);
    }
    state.connectedUser = user;
  },
};

export default {
  namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
